import './Ai2Navbar.css';


function Ai2Navbar() {
    let username = localStorage.getItem('username');

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <img src='https://viron.network/assets/img/Ai2Logo.png' alt="Logo" className="logo" />
                <div className='navTitle'>
                    <h2>Ai AWARENESS INSTITUTE</h2>
                </div>
            </div>
            <div className="navbar-right">
                {/* <p style={{padding:"10px"}}>@{username}</p>
      <img
          src="https://www.w3schools.com/howto/img_avatar.png"
          alt="Profile"
          className="profile-pic"
        />*/}
            </div>
        </nav>
    );
}

export default Ai2Navbar;
